const own=(object,key)=>Object.prototype.hasOwnProperty.call(object||{},key);
export const guardValue=value=>value===true?'yes':value===false?'no':'';
export const guardLabel=value=>value===true?'Guard on':value===false?'No guard':'Guard not recorded';
const parsed=value=>value==='yes'?true:value==='no'?false:null;
export function guardEditCerts(session){
  return Object.entries(session.guardItems||{}).filter(([,item])=>!own(item,'expected')||item.hasGuard!==item.expected).map(([cert])=>cert);
}

export function editGuard(session,cert,value,expected,{reconfirm=false}={}){
  const items={...session.guardItems},old=items[cert];
  items[cert]={hasGuard:parsed(value),...(reconfirm&&expected!==undefined?{expected:expected??null}:old&&own(old,'expected')?{expected:old.expected}:expected!==undefined?{expected:expected===true?true:expected===false?false:null}:{})};
  return {...session,guardItems:items};
}
export function trackGuard(session,cert,expected){
  return session.guardDefault&&!session.guardItems?.[cert]?editGuard(session,cert,session.guardDefault,expected):session;
}
export function bindGuardExpected(session,cert,saved){
  const item=session.guardItems?.[cert];
  if(!item||own(item,'expected'))return session;
  return {...session,guardItems:{...session.guardItems,[cert]:{...item,expected:saved===true?true:saved===false?false:null}}};
}
// A failed identity read must not leave an explicit guard choice permanently
// stuck without a way to retry. Only bind the baseline from a verified read;
// never assume that an unavailable lookup means the saved value is unknown.
export async function resolveGuardChecks(session,certs,check,canonicalize){
  let current=session;
  for(const cert of certs){
    const item=current.guardItems?.[cert];
    if(!item||own(item,'expected'))continue;
    let result;
    try{result=await check(cert);}catch(error){throw Error(`#${cert}: ${error.message||'Inventory check unavailable'}`);}
    const canonical=result?.slab?.certNumber;
    const alias=result?.existing&&/^\d{4,12}$/.test(cert)&&/^\d{4,12}$/.test(canonical||'')&&cert.replace(/^0+/,'')===canonical.replace(/^0+/,'');
    if(result?.status!=='ready'||!(canonical===cert||alias&&canonicalize)||![true,false,null].includes(result.slab?.hasGuard))throw Error(`Could not check the saved guard for #${cert}. Retry the inventory check; your scans and guard choice are kept.`);
    if(canonical!==cert)current=canonicalize(current,cert,canonical);
    current=bindGuardExpected(current,canonical,result.slab.hasGuard);
  }
  return current;
}
export function mergeGuardAlias(session,oldCert,cert){
  if(oldCert===cert||!session.guardItems?.[oldCert])return session;
  const items={...session.guardItems};if(!items[cert])items[cert]=items[oldCert];delete items[oldCert];
  return {...session,guardItems:items};
}
export function guardPayload(session,certs){
  const result={},allowed=new Set(certs);
  for(const[cert,item]of Object.entries(session.guardItems||{})){
    if(!allowed.has(cert))continue;
    if(!own(item,'expected')||![true,false,null].includes(item.hasGuard)||![true,false,null].includes(item.expected))throw Error(`Wait for the guard check for #${cert}, then save again.`);
    if(item.hasGuard!==item.expected)result[cert]={hasGuard:item.hasGuard,expected:item.expected};
  }
  return Object.keys(result).length?result:null;
}
